import html from './html';

const language = html.lang || 'de';

export default language;
